/* eslint-disable no-console */
const MOCK = process.env.REACT_APP_ENV_MOCK === "1";
const DEBUG = process.env.REACT_APP_ENV_DEVELOPMENT === "1";
const PRODUCTION = !MOCK && !DEBUG;

const Environments = {
    DEBUG,
    MOCK,
    PRODUCTION,
};

export default Environments;
